/**
 * Single source of truth for PayNovus AD company / legal / brand info.
 * Mirror of supabase/functions/_shared/company-info.ts — keep in sync.
 *
 * Use this in client-side PDF generators, statements, footers, and any
 * UI that displays the legal entity, address, support contact, or brand
 * colors. Do NOT hard-code these values anywhere else.
 */
// ⚠ KEEP IN SYNC with supabase/functions/_shared/company-info.ts — duplicate copy used by edge-function PDFs/emails. Any change here must be mirrored there.

export const COMPANY_INFO = {
  legal_name: 'PayNovus AD',
  uic: '206566032',
  license_body: 'Bulgarian National Bank',
  license_type: 'Payment Institution',
  registered_address: {
    building: 'Perform Business Center',
    line1: 'Pozitano Sq 2',
    district: 'Sofia Center',
    postal_code: '1000',
    city: 'Sofia',
    country: 'Bulgaria',
  },
  support_email: 'support@paynovus.com',
  support_phone: '+359 2 491 99 99',
  noreply_email: 'noreply@paynovus.com',
  website: 'https://paynovus.com',
  // Public logo URL — served from the customer portal. Update when a
  // canonical public logo asset is published under /public.
  logo_url: 'https://core.paynovus.com/favicon.svg',
  brand_colors: {
    primary: '#1a2a3e',   // navy — hsl(218 65% 12%)
    accent: '#a8e635',    // lime — hsl(75 85% 60%)
    text: '#0a0a0a',
    muted: '#737373',
  },
} as const;

export type CompanyInfo = typeof COMPANY_INFO;

/** "Perform Business Center, Pozitano Sq 2, Sofia Center, Sofia 1000, Bulgaria" */
export function formatAddressOneLine(info: CompanyInfo = COMPANY_INFO): string {
  const a = info.registered_address;
  return `${a.building}, ${a.line1}, ${a.district}, ${a.city} ${a.postal_code}, ${a.country}`;
}

/** "PayNovus AD is authorised and regulated by the Bulgarian National Bank." */
export function regulatoryStatement(info: CompanyInfo = COMPANY_INFO): string {
  return `${info.legal_name} is authorised and regulated by the ${info.license_body}.`;
}
